import React from 'react';
import { Col, Row } from 'react-bootstrap';
import { SvgIcon } from '@mui/material';
import { Check as CheckIcon } from '@mui/icons-material';
import UserIcon from '../../../../icons/user1.svg?react';
import './HelpSection.scss'

export default function HelpSection() {

  return (
    <div className="help-section">
      <hr className="divider"></hr>
      <div >
        <h4>Questions? Need help?</h4>
        <h5>We're here to help. Ask us anything.</h5>
        <Row className="mt-4 d-flex justify-content-center">
          <Col xs="auto" className="">
            <SvgIcon component={UserIcon} fontSize="large" color="primary" className="my-0" />
          </Col>
          <Col xs="auto" sm={7} md={8} className="p-0">
            <h5>Our Experts</h5>
            <ul className="p-0">
              <li><CheckIcon color="primary" className="me-1" />Licensed in all 50 states</li>
              <li><CheckIcon color="primary" className="me-1" />Salaried employees</li>
              <li><CheckIcon color="primary" className="me-1" />Provide personalized service</li>
              <li><CheckIcon color="primary" className="me-1" />Knowledgeable &amp; friendly</li>
            </ul>
          </Col>
        </Row>
      </div>
    </div>
  )
}
